// extracted by mini-css-extract-plugin
export default {"pagination":"styles_pagination__ABJqr","button-pages":"styles_button-pages__2QAWe","active":"styles_active__zNr1H","disabled":"styles_disabled__GL4Ak"};